import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

var startDate = new Date();
startDate.setFullYear(startDate.getFullYear() - 14);
export const ProfileSetup = createSlice({
  name: "ProfileSetup",
  initialState: {
    value: {
      status: false,
      isProfileSetup: false,
      tryCounter: 0,
      userId: "",
      username: "",
      firstname: "",
      lastname: "",
      phonenumber: "",
      adminType: "",
      department: "",
      location: "",
      email: "",
      country: "+234 Nigeria",
      usertype: "Farmer",
      gender: "",
      dateofbirth: dayjs(startDate) || "",
      profileImageUrl: "",
      profileSetupRole: 2001,
      languagePreference: "en",
      referral: "",
    },
  },
  reducers: {
    profileSetupUpdateUsertype: (state, action) => {
      state.value.firstname = action.payload?.firstname;
      state.value.lastname = action.payload?.lastname;
      state.value.username = action.payload?.username;
      state.value.phonenumber = action.payload?.phonenumber;
      state.value.country = action.payload?.country;
      state.value.usertype = action.payload?.usertype;
      state.value.referral = action.payload?.referral;
    },
    usertypeUpdate: (state, action) => {
      state.value.status = true;
      state.value.tryCounter = 0;
      state.value.isProfileSetup = action.payload?.isProfileSetup
        ? action.payload?.isProfileSetup
        : state.value.isProfileSetup;
      state.value.userId = action.payload?.userId
        ? action.payload?.userId
        : state.value.userId;
      state.value.username = action.payload?.username
        ? action.payload?.username
        : state.value.username;
      state.value.email = action.payload?.email
        ? action.payload?.email
        : state.value.email;
      state.value.firstname = action.payload?.firstname
        ? action.payload?.firstname
        : state.value.firstname;
      state.value.lastname = action.payload?.lastname
        ? action.payload?.lastname
        : state.value.lastname;
      state.value.phonenumber = action.payload?.phonenumber
        ? action.payload?.phonenumber
        : state.value.phonenumber;
      state.value.adminType = action.payload?.adminType
        ? action.payload?.adminType
        : state.value.adminType;
      state.value.department = action.payload?.department
        ? action.payload?.department
        : state.value.department;
      state.value.location = action.payload?.location
        ? action.payload?.location
        : state.value.location;
      state.value.country = action.payload?.country
        ? action.payload?.country
        : state.value.country;
      state.value.usertype = action.payload?.usertype
        ? action.payload?.usertype
        : state.value.usertype;
      state.value.gender = action.payload?.gender
        ? action.payload?.gender
        : state.value.gender;
      state.value.dateofbirth = action.payload?.dateofbirth
        ? action.payload?.dateofbirth
        : state.value.dateofbirth;
      state.value.profileImageUrl = action.payload?.profileImageUrl
        ? action.payload?.profileImageUrl
        : state.value.profileImageUrl;
      state.value.languagePreference = action.payload?.languagePreference
        ? action.payload?.languagePreference
        : "en";
      state.value.referral = action.payload?.referral
        ? action.payload?.referral
        : state.value.referral;
    },
    genderUpdate: (state, action) => {
      state.value.gender = action.payload;
    },
    dateofbirthUpdate: (state, action) => {
      state.value.dateofbirth = action.payload;
    },
    userIdUpdate: (state, action) => {
      state.value.userId = action.payload;
    },
    updateIsProfileSetup: (state, action) => {
      state.value.isProfileSetup = action.payload;
    },
    updateTryCounter: (state, action) => {
      state.value.tryCounter = action.payload;
    },
    updateProfileImage: (state, action) => {
      state.value.profileImageUrl = action.payload;
    },
    updateUserame: (state, action) => {
      state.value.username = action.payload;
    },
    updatePrfStpRole: (state, action) => {
      state.value.profileSetupRole = action.payload?.setupRole;
    },
    updateLangPreference: (state, action) => {
      state.value.languagePreference = action.payload?.languagePreference;
    },
    resetProfile: (state, action) => {
      state.value = {
        status: false,
        isProfileSetup: false,
        tryCounter: 0,
        userId: "",
        username: "",
        firstname: "",
        lastname: "",
        phonenumber: "",
        adminType: "",
        department: "",
        location: "",
        email: "",
        country: "+234 Nigeria",
        usertype: "Farmer",
        gender: "",
        dateofbirth: "",
        profileImageUrl: "",
        profileSetupRole: 2001,
        languagePreference: "en",
        referral: "",
      };
    },
  },
});

export const {
  profileSetupUpdateUsertype,
  usertypeUpdate,
  genderUpdate,
  dateofbirthUpdate,
  userIdUpdate,
  updateIsProfileSetup,
  updateTryCounter,
  updateProfileImage,
  resetProfile,
  updateUserame,
  updatePrfStpRole,
  updateLangPreference,
} = ProfileSetup.actions;

export default ProfileSetup.reducer;
